// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2B55T","whiteMode":"styles_whiteMode__ALfHc"};